import { useEffect, useState } from 'react'
import { mapBrazePageName } from '../../Utils/inAppMessaging'
import { normalizePageName } from '../../Utils/Window/windowHelpers'

type LocationState = {
  pathname: string
  search: string
  pageName: string
  brazePageName: string
}

/**
 * Lazy hook to get location instead of heavy React Router useLocation
 * Includes window checks for SSR safety and stores current pathname/pageName
 */
export const useLazyLocation = (shouldLoad: boolean): LocationState | null => {
  const [location, setLocation] = useState<LocationState | null>(null)

  useEffect(() => {
    if (!shouldLoad) return
    if (typeof window === 'undefined') return
    if (!window?.location || !window?.history) return

    updateLocation()

    const handlePopState = () => updateLocation()
    window.addEventListener('popstate', handlePopState)
    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args)
      updateLocation()
    }

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args)
      updateLocation()
    }

    return () => {
      window.removeEventListener('popstate', handlePopState)
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
    }
  }, [shouldLoad])


  const updateLocation = () => {
    const pathname = window.location.pathname
    const search = window.location.search
    const pageName = normalizePageName(pathname) ?? 'pll_stats'
    const brazePageName = mapBrazePageName(pageName) ?? ''

    setLocation({
      pathname,
      search,
      pageName,
      brazePageName
    })
  }

  return location
}
